import { Factory } from 'rosie';

Factory.define('UsersAdmin').attr('name', 'USERS_ADMIN');

Factory.define('UsersAdminWithDefaults').extend('UsersAdmin');



// WEBPACK FOOTER //
// ./factories/location/users_admin.js